export const fetchFileReport = {
  pathname: (value) => `/api/v4/files/report/${value}`
}
